import { SchemaVersionEnum } from "../models/schema";
import { DefaultSchemaRules } from "../models/defaultRules";
import { GeneralLoanInfoVisibleFields } from "../models/fields";
const updateToMostRecentSchemaVersion = (schema, lastVersionToUpdateTo) => {
  const latestVersion = lastVersionToUpdateTo ?? Object.keys(SchemaVersionEnum).length / 2 - 1;
  let currentVersion = schema.version ?? SchemaVersionEnum.V0;
  while (currentVersion < latestVersion) {
    const flattenedFields = schema.schema.screens.filter((i) => i.type === "screen").flatMap(
      (screen) => screen.fields.flatMap(
        (fieldGroup) => fieldGroup.fields
      )
    );
    const flattenedRules = schema.schemaRules.flatMap((rule) => rule);
    switch (currentVersion) {
      case SchemaVersionEnum.V0:
        schema.schema.screens.filter((i) => i.type === "screen").forEach((screen) => {
          screen.fields.forEach(
            (fieldGroup) => {
              if (fieldGroup.fields && Array.isArray(fieldGroup.fields)) {
                fieldGroup.fields.filter((field) => field.type !== "field_group").map((field) => field).filter((field) => field.component_id?.startsWith("CUSTOM")).forEach((field) => {
                  if (!field.encompass_ids) {
                    field.encompass_ids = [
                      {
                        modelPath: field.modelPath || "",
                        description: field.component_id || "",
                        id: field.modelPath || ""
                      }
                    ];
                  }
                  field.encompass_ids[0].modelPath = `unmappedLockRequestAdditionalFields.${field.encompass_ids[0].id.replaceAll(".", "*")}`;
                });
              }
            }
          );
        });
        break;
      case SchemaVersionEnum.V1: {
        const cashOutField = flattenedFields.find(
          (i) => i.id === "7c272b62-b841-46d0-9d98-a1a3825ca121"
        );
        if (cashOutField) {
          cashOutField.visible = true;
        }
        schema.schemaRules.filter((rule) => rule.id === "d72d3321-a47a-4b43-be78-54a8a7e0ced2").forEach((subRule) => {
          if (Array.isArray(subRule.instructions)) {
            subRule.instructions.filter((i) => i.id === "3234cf2e-026f-46cb-9f22-7859e3f782a6").forEach((instruction) => {
              if (instruction.condition && Array.isArray(instruction.condition.params)) {
                instruction.condition.params = [
                  {
                    op: "isFieldNotEqualToValue",
                    params: ["loanInformation.loanPurpose", "3"]
                  },
                  {
                    op: "213beec3-7caf-45be-9cec-67359ee890b3"
                  }
                ];
              }
            });
          }
        });
        break;
      }
      case SchemaVersionEnum.V2: {
        schema.schema.screens.filter((i) => i.type === "screen").forEach((screen) => {
          if (screen.id === "3cd6556e-a5e0-4c02-95ae-8da91a866ea0") {
            screen.fields.filter((field) => field.name === "VISIBLE").forEach((fieldGroup) => {
              fieldGroup.fields.forEach((field) => {
                const idToModelPath = {
                  "107ee0fe-ef21-4ba4-a52a-59793f7fcef4": "borrowerFinancialHistory.docTypeEmployment",
                  "5ce9c244-8cb3-45fa-98a1-a7bae86dd6e0": "borrowerFinancialHistory.docTypeAsset",
                  "9552759a-2a01-4057-9e3f-58461349d1ff": "borrowerFinancialHistory.docTypeIncome"
                };
                fieldGroup.fields.forEach((field2) => {
                  const newModelPath = field2.id !== void 0 ? idToModelPath[field2.id] : void 0;
                  field2.modelPath = newModelPath || field2.modelPath;
                  if (newModelPath && field2.encompass_ids != null && field2.encompass_ids.length > 0 && field2.encompass_ids[0] != null) {
                    field2.encompass_ids[0].modelPath = newModelPath;
                  }
                });
              });
            });
          }
        });
        schema.schemaRules.filter(
          (rule) => rule.id === "ef8adce9-1a09-4b33-8526-2702f7d12581" || rule.id === "829c15f3-68f2-4161-b44a-7361ec9d02bc"
        ).forEach((subRule) => {
          if (Array.isArray(subRule.instructions)) {
            const idToParams = {
              "16089a15-d462-4d97-b2d9-67e9836ba839": [
                {
                  op: "isFieldEqualToValue",
                  params: ["borrowerFinancialHistory.docTypeIncome", "100"]
                },
                {
                  op: "isFieldEqualToValue",
                  params: ["borrowerFinancialHistory.docTypeIncome", "70"]
                }
              ],
              "fcdc6ee1-bde0-4f68-ac39-058fee7ce3c4": [
                {
                  op: "isFieldEqualToValue",
                  params: ["standardProducts", "6"]
                },
                {
                  op: "isFieldEqualToValue",
                  params: ["borrowerFinancialHistory.docTypeIncome", "0"]
                }
              ]
            };
            subRule.instructions = subRule.instructions.map((instruction) => {
              const newParams = idToParams[instruction.id];
              if (newParams) {
                instruction.condition.params = newParams;
              }
              return instruction;
            });
          }
        });
        break;
      }
      case SchemaVersionEnum.V3: {
        const loanTermField = flattenedFields.find(
          (i) => i.id === "cb3f524e-8051-4a14-a0a2-e488c07ced41"
        );
        if (loanTermField) {
          loanTermField.required = false;
        }
        break;
      }
      case SchemaVersionEnum.V4: {
        const effectiveDateField = flattenedFields.find(
          (field) => field.id === "4e60c809-e23f-4d63-97fd-934f1036312e"
        );
        if (effectiveDateField) {
          effectiveDateField.disabled = true;
          effectiveDateField.disable_check = {
            handler: "1f2f6425-fa45-407a-9f6e-dab82f658282"
          };
        }
        flattenedRules.find(
          (rule) => rule.id === DefaultSchemaRules.IsBuysideSellsideOrValidateView.id
        ).instructions[0].condition.params = [
          "isBuyside",
          "isSellside",
          "isValidate"
        ].map((path) => ({
          op: "isFieldEqualToValue",
          params: [`nonLoanValues.${path}`, "true"]
        }));
        flattenedRules.push(
          DefaultSchemaRules.EnableEffectiveDateonNewLock,
          DefaultSchemaRules.EnableEffectiveDateonRelock,
          DefaultSchemaRules.EnableEffectiveDate
        );
        break;
      }
      case SchemaVersionEnum.V5: {
        const GovtFeeField = GeneralLoanInfoVisibleFields?.find(
          (field) => field.id === "33bdb99e-4dfc-4767-9994-362cec731353"
        );
        const VAExemptFieldToAdd = GovtFeeField?.fields?.find(
          (field) => field.id === "3039d8c7-868a-4cec-8bff-59998faaf59d"
        );
        const firstTimeFieldToAdd = GovtFeeField?.fields?.find(
          (field) => field.id === "387f069e-9c3b-49bf-81de-dd157d2799f7"
        );
        const govtFeesFieldGroup = flattenedFields.find(
          (field) => field.id === "33bdb99e-4dfc-4767-9994-362cec731353"
        );
        if (!govtFeesFieldGroup) {
          break;
        }
        if (govtFeesFieldGroup.fields?.findIndex(
          (field) => field.id === VAExemptFieldToAdd?.id
        ) === -1) {
          govtFeesFieldGroup.fields.push(VAExemptFieldToAdd);
        }
        if (govtFeesFieldGroup.fields?.findIndex(
          (field) => field.id === firstTimeFieldToAdd?.id
        ) === -1) {
          govtFeesFieldGroup.fields.push(firstTimeFieldToAdd);
        }
        break;
      }
      case SchemaVersionEnum.V7: {
        const loanOfficerField = flattenedFields.find(
          (field) => field.id === "f25c8e38-d069-4bbe-8180-485c747f5c25"
        );
        if (loanOfficerField) {
          loanOfficerField.visible = true;
          delete loanOfficerField.visible_check;
          loanOfficerField.disabled = true;
          loanOfficerField.disable_check = {
            handler: "62af1e06-20c3-4904-ba36-166c5ba2daf1"
          };
        }
        const loanOfficerRule = flattenedRules.find(
          (rule) => rule.id === "62af1e06-20c3-4904-ba36-166c5ba2daf1"
        );
        if (loanOfficerRule) {
          loanOfficerRule.instructions[0].condition.params = [
            {
              op: "isFieldEqualToValue",
              params: ["nonLoanValues.userRights", "28"]
            }
          ];
        } else {
          schema.schemaRules.push(
            DefaultSchemaRules.UserRightsCanSetLoanOfficer
          );
        }
        break;
      }
      case SchemaVersionEnum.V8: {
        const noClosingCostField = flattenedFields.find(
          (field) => field.id === "e759e74a-7f2c-4f69-80ab-37b75d0203a8"
        );
        if (noClosingCostField) {
          noClosingCostField.visible = false;
          noClosingCostField.visible_check = {
            handler: DefaultSchemaRules.ShowNoClosingCosts.id
          };
        }
        const showNoClosingCostsRule = flattenedRules.find(
          (rule) => rule.id === DefaultSchemaRules.ShowNoClosingCosts.id
        );
        if (!showNoClosingCostsRule) {
          schema.schemaRules.push(DefaultSchemaRules.ShowNoClosingCosts);
        }
        break;
      }
      case SchemaVersionEnum.V9: {
        const simpleSearchColSizeById = {
          "5fbc3d59-24fa-45bf-898a-e340eced1c07": 2,
          "cb3f524e-8051-4a14-a0a2-e488c07ced41": 2,
          "fa98ef18-bf10-40b2-8334-ca4627e718f5": 3,
          "3a5f2d3f-91b9-4d34-9bdc-ee80081a66fa": 3,
          "7c327485-f6dd-4aa5-a9fe-a4b85790cf4f": 2
        };
        flattenedFields.forEach((field) => {
          const newColSize = field.id !== void 0 ? simpleSearchColSizeById[field.id] : void 0;
          if (newColSize !== void 0 && field.ui) {
            field.ui.col_size = newColSize;
          }
        });
        break;
      }
      case SchemaVersionEnum.V10: {
        const isNonQmDocLevel = flattenedRules.find(
          (rule) => rule.id === DefaultSchemaRules.IsNonQmDocLevel.id
        );
        if (!isNonQmDocLevel) {
          flattenedRules.push(DefaultSchemaRules.IsNonQmDocLevel);
        }
        break;
      }
      case SchemaVersionEnum.V6: {
        const oldHelocRule = flattenedRules.find(
          (rule) => rule.id === "322159db-fd06-4203-88cc-ba7dd14707bc"
        );
        if (oldHelocRule) {
          flattenedRules.splice(flattenedRules.indexOf(oldHelocRule), 1);
        }
        const loanIsSecondAndHelocRule = flattenedRules.find(
          (rule) => rule.id === "f377baba-059d-423f-8702-de8281d8ec57"
        );
        if (loanIsSecondAndHelocRule) {
          loanIsSecondAndHelocRule.instructions[0].condition.params = [
            {
              op: "213beec3-7caf-45be-9cec-67359ee890b3"
            },
            {
              op: "305c1831-0004-4a2e-8cdb-6bf85c1a0029"
            }
          ];
        }
        const initialDrawField = flattenedFields.find(
          (field) => field.id === "97251514-e679-4589-836d-98f9ab4f163b"
        );
        if (initialDrawField) {
          initialDrawField.visible_check = {
            handler: "322159db-fd06-4203-88cc-ba7dd14707bc"
          };
        }
        const maxLineField = flattenedFields.find(
          (field) => field.id === "21aea877-8f9a-4be7-a3aa-1e7091e5db4d"
        );
        if (maxLineField) {
          maxLineField.visible_check = {
            handler: "213beec3-7caf-45be-9cec-67359ee890b3"
          };
        }
        break;
      }
      default:
        break;
    }
    currentVersion = currentVersion + 1;
  }
  schema.version = currentVersion;
  return;
};
const getEppsLookupMapperObject = (modelPath) => {
  const modelPathToLookup = {
    "borrowerFinancialHistory.bkType": () => ({
      key: "bankruptcyType",
      value: "bankruptcyTypeId",
      text: "descriptionText"
    }),
    buydownContributor: () => ({
      key: "buydownContributorType",
      value: "buydownContributorTypeId",
      text: "descriptionText"
    }),
    buydownType: () => ({
      key: "buydownType",
      value: "buydownTypeId",
      text: "descriptionText"
    }),
    "loanInformation.commitmentType": () => ({
      key: "commitmentTypes",
      value: "commitmentTypeID",
      text: "description"
    }),
    "borrowers[0].citizenship": () => ({
      key: "citizenship",
      value: "citizenshipId",
      text: "citizenship"
    }),
    "borrowerFinancialHistory.noticeOfDefaultForeClosure": () => ({
      key: "foreclosure",
      value: "value",
      text: "key"
    }),
    "loanInformation.lienPosition": () => ({
      key: "lienPos",
      value: "value",
      text: "key"
    }),
    productType: () => ({
      key: "loanTerms",
      value: "value",
      text: "key"
    }),
    "loanInformation.loanPurpose": () => ({
      key: "loanUsage",
      value: "value",
      text: "key"
    }),
    "borrowerFinancialHistory.nodType": () => ({
      key: "nodTypes",
      value: "nodTypeID",
      text: "description"
    }),
    "borrowerFinancialHistory.nonQMDocLevel": () => ({
      key: "nonQMDocLevel",
      value: "nonQMDocLevelTypeId",
      text: "descriptionText"
    }),
    "loanInformation.prepaymentPenaltyTerm": () => ({
      key: "prepayPenaltyTerms",
      value: "value",
      text: "key"
    }),
    "loanInformation.underwritingMethodID": () => ({
      key: "underwritingMethods",
      value: "underwritingMethodID",
      text: "underwritingMethod"
    }),
    productOptions: () => ({
      key: "productOptions",
      value: "value",
      text: "key"
    }),
    "property.type": () => ({
      key: "propertyTypes",
      value: "value",
      text: "key"
    }),
    "property.use": () => ({
      key: "propertyUse",
      value: "value",
      text: "key"
    }),
    specialProducts: () => ({
      key: "specialProducts",
      value: "value",
      text: "key"
    }),
    standardProducts: () => ({
      key: "standardProducts",
      value: "value",
      text: "key"
    }),
    "property.state": () => ({
      key: "states",
      value: "abbreviation",
      text: "abbreviation"
    }),
    "property.unitTypeId": () => ({
      key: "unitTypes",
      value: "unitTypeID",
      text: "description"
    }),
    lockDays: () => ({
      key: "lockdays",
      value: "lockDays",
      text: "lockDays"
    })
  };
  return modelPathToLookup[modelPath] ? modelPathToLookup[modelPath]() : null;
};
const mapAllEnumOptions = (field, lookups) => {
  const mapperObject = getEppsLookupMapperObject(
    field?.encompass_ids?.[0]?.modelPath
  );
  const existsInLookups = mapperObject ? lookups[mapperObject.key] : false;
  if (mapperObject && existsInLookups) {
    field.options = lookups[mapperObject.key].map((lookup) => {
      const existingOption = field.options?.find(
        (option2) => option2.id === lookup[mapperObject.text]
      );
      const option = {
        id: lookup[mapperObject.text],
        text: existingOption ? existingOption.text : lookup[mapperObject.text],
        value: String(lookup[mapperObject.value]),
        visible: existingOption ? existingOption.visible : true
      };
      return option;
    });
  }
  return field;
};
const processFieldOptionsFromLookups = (field, lookups) => {
  let flattenedField = [field];
  if (field.type === "field_group") {
    flattenedField = field.fields;
  }
  flattenedField.map((field2) => {
    if (field2.type === "enum" && field2.options) {
      return mapAllEnumOptions(field2, lookups);
    }
    return field2;
  });
  return field;
};
const applyClientLookupsToSchema = (schemaAndRules, allLookupValues) => {
  schemaAndRules.schema.screens = schemaAndRules.schema.screens.map(
    (screen) => {
      if (screen.type === "screen") {
        screen.fields = screen.fields.map((displayGroup) => {
          displayGroup.fields = displayGroup.fields.map(
            (fieldOrFieldGroup) => {
              return processFieldOptionsFromLookups(
                fieldOrFieldGroup,
                allLookupValues
              );
            }
          );
          return displayGroup;
        });
      }
      return screen;
    }
  );
  return schemaAndRules;
};
const filterFieldsNotIncludedInDefaultSchema = (fields) => {
  const fieldsToRemove = ["UW Methods"];
  return fields.filter(
    (field) => !fieldsToRemove.includes(field.component_id ?? "")
  );
};
export {
  applyClientLookupsToSchema,
  filterFieldsNotIncludedInDefaultSchema,
  processFieldOptionsFromLookups,
  updateToMostRecentSchemaVersion
};
